<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <div class="col-md-12">
                <h5>Solicitar Adiantamento</h5>
              </div>
            </div>

            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'advance-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'advance-card-dark'
                    : 'advance-card-light',
                ]"
              >
                <div class="advance-card-header">
                  <i
                    class="fas fa-money-bill-wave text-success"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-success advance-card-title">
                    Dados do Adiantamento
                  </h3>
                  <div
                    class="advance-card-line"
                    style="border-color: #28a745; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-label-dark'
                          : 'advance-label-light'
                      "
                      ><span class="required">*</span> Nome do
                      Colaborador</label
                    >
                    <input
                      v-if="!isAccessNivel"
                      type="text"
                      :value="$store.state.user.name"
                      disabled
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-input-dark'
                          : 'advance-input-light',
                      ]"
                    />
                    <v-select
                      v-else
                      id="userTop"
                      v-model="advance.user_id"
                      :options="users"
                      :reduce="(user) => user.id"
                      label="name"
                      @input="fillUserData"
                      :class="[
                        'advance-select',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-select-dark'
                          : 'advance-select-light',
                      ]"
                    />
                  </div>

                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-label-dark'
                          : 'advance-label-light'
                      "
                      ><span class="required">*</span> Valor do
                      adiantamento</label
                    >
                    <input
                      v-model="advance_amount"
                      type="text"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-input-dark'
                          : 'advance-input-light',
                      ]"
                      v-money="moneyConfig"
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="dinnerAdvanceSwitch"
                        v-model="advance.is_dinner_advance"
                      />
                      <label
                        class="custom-control-label"
                        :class="
                          $store.state.appConfig.layout.skin === 'dark'
                            ? 'advance-label-dark'
                            : 'advance-label-light'
                        "
                        for="dinnerAdvanceSwitch"
                      >
                        É um adiantamento de jantar?
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-label-dark'
                          : 'advance-label-light'
                      "
                      ><span class="required">*</span> Justificativa</label
                    >
                    <textarea
                      v-model="advance.justification"
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'advance-input-dark'
                          : 'advance-input-light',
                      ]"
                      rows="4"
                      placeholder="Explique o motivo da solicitação do adiantamento"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <span class="required_fields">
                <span class="required">*</span>
                <strong> Campos obrigatórios</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link to="/advances" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a class="btn btn-add ml-1" @click="saveAdvance">
                  Solicitar
                  <i class="fa fa-paper-plane"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Money from "v-money";

export default {
  data() {
    return {
      users: [],
      advance: {
        user_id: null,
        justification: "",
        is_dinner_advance: false,
      },
      advance_amount: "",
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    // Após F5 o store volta zerado até o /me responder (profileUpdate),
    // então aguarda o perfil carregar antes de checar permissões
    waitForProfile() {
      if (this.$store.state.user.id) return Promise.resolve();
      return new Promise((resolve) => {
        const unwatch = this.$watch(
          () => this.$store.state.user.id,
          (id) => {
            if (id) {
              unwatch();
              resolve();
            }
          }
        );
      });
    },
    getUsers() {
      const self = this;
      const api = self.$store.state.api + "users_solicitation?paginated=false";
      axios
        .get(api)
        .then((response) => {
          self.users = response.data.users;
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro ao carregar usuários",
            "error"
          );
        });
    },

    fillUserData(userId) {
      // Método para preencher dados do usuário se necessário
      const selectedUser = this.users.find((user) => user.id === userId);
      if (selectedUser) {
        // Lógica adicional se precisar preencher outros campos
      }
    },

    convertCurrencyToNumber(currencyString) {
      const cleanedString = currencyString
        .replace(/\s|R\$/g, "")
        .replace(/\./g, "");
      const dotFormattedString = cleanedString.replace(",", ".");
      const numberValue = parseFloat(dotFormattedString);
      return isNaN(numberValue) ? 0 : numberValue;
    },

    async saveAdvance() {
      const self = this;

      if (self.isAccessNivel && !self.advance.user_id) {
        this.$message(null, "Selecione um colaborador", "error");
        return;
      }

      if (
        !self.advance_amount ||
        self.convertCurrencyToNumber(self.advance_amount) <= 0
      ) {
        this.$message(
          null,
          "Informe um valor válido para o adiantamento",
          "error"
        );
        return;
      }

      if (!self.advance.justification || !self.advance.justification.trim()) {
        this.$message(null, "Informe a justificativa da solicitação", "error");
        return;
      }

      // O backend força o próprio usuário quando quem solicita não é gestor
      const payload = {
        advance_amount: self.convertCurrencyToNumber(self.advance_amount),
        is_dinner_advance: self.advance.is_dinner_advance ? 1 : 0,
        justification: self.advance.justification.trim(),
      };
      if (self.isAccessNivel) {
        payload.user_id = self.advance.user_id;
      }

      try {
        self.$loading(true);
        const response = await axios.post(
          self.$store.state.api + "advances/request",
          payload
        );
        this.$message("Sucesso", response.data.message, "success");
        this.$router.push("/advances");
      } catch (error) {
        this.$message(
          null,
          error.response?.data?.message || "Erro ao solicitar adiantamento",
          "error"
        );
      } finally {
        self.$loading(false);
      }
    },
  },

  async mounted() {
    const self = this;

    await self.waitForProfile();

    // Gestores (RH/Geral) podem solicitar em nome de outro colaborador
    if (self.isAccessNivel) {
      self.advance.user_id = self.$store.state.user.id;
      self.getUsers();
    }
    // Inicializar o campo com R$ 0,00
    self.$nextTick(() => {
      self.advance_amount = "R$ 0,00";
    });
  },

  components: {
    BaseCrud,
    vSelect,
    Money,
  },

  computed: {
    isAccessNivel() {
      return (
        this.$store.state.user.perfil_id === 8 ||
        this.$store.state.user.perfil_id === 7
      );
    },
  },
};
</script>

<style scoped>
.required {
  color: rgb(255, 0, 0);
}

.required_fields {
  font-size: 12px;
  color: #666;
}

/* ===== ESTILIZAÇÃO MODERNA - IGUAL DASP ===== */

/* Cards - Classes separadas para dark e light */
.advance-card {
  border-radius: 12px;
  padding: 24px 18px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.advance-card-dark {
  background: #191e2e;
  border: 1px solid #4a5568;
}

.advance-card-light {
  background: #f8f8fa;
  border: 1px solid #e2e6ea;
}

.advance-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.advance-card-title {
  font-weight: 700;
}

.advance-card-line {
  flex: 1;
  border-bottom: 4px solid;
  margin-left: 16px;
  opacity: 0.6;
}

/* Labels */
.advance-label-dark {
  color: #e2e8f0;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.advance-label-light {
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

/* Inputs */
.advance-input-dark {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.advance-input-light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
}

/* v-select Dark */
.advance-select-dark .vs__dropdown-toggle {
  background: #2d3748;
  border: 1px solid #4a5568;
}

.advance-select-dark .vs__selected {
  color: #e2e8f0;
}

.advance-select-dark .vs__search::placeholder {
  color: #a0aec0;
}

.advance-select-dark .vs__dropdown-menu {
  background: #2d3748;
  border: 1px solid #4a5568;
}

.advance-select-dark .vs__dropdown-option {
  color: #e2e8f0;
}

.advance-select-dark .vs__dropdown-option--highlight {
  background: #007bff;
  color: white;
}

.advance-select-dark .vs__no-options {
  color: #a0aec0;
}

.advance-select-dark .vs__clear {
  color: #a0aec0;
}

.advance-select-dark .vs__open-indicator {
  color: #a0aec0;
}

/* v-select Light */
.advance-select-light .vs__dropdown-toggle {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.advance-select-light .vs__selected {
  color: #2d3748;
}

.advance-select-light .vs__search::placeholder {
  color: #6c757d;
}

.advance-select-light .vs__dropdown-menu {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.advance-select-light .vs__dropdown-option {
  color: #2d3748;
}

.advance-select-light .vs__dropdown-option--highlight {
  background: #007bff;
  color: white;
}

.advance-select-light .vs__no-options {
  color: #6c757d;
}

.advance-select-light .vs__clear {
  color: #6c757d;
}

.advance-select-light .vs__open-indicator {
  color: #6c757d;
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 768px) {
  .advance-card {
    padding: 1rem 0.75rem !important;
    margin-bottom: 1rem;
  }

  .advance-card-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .advance-card-header i {
    font-size: 18px !important;
  }

  .advance-card-title {
    font-size: 1.1rem !important;
    margin: 0 !important;
  }

  .advance-card-line {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }

  .advance-label-dark,
  .advance-label-light {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
}

/* ===== RESPONSIVIDADE TABLET ===== */
@media (min-width: 769px) and (max-width: 1024px) {
  .advance-card {
    padding: 1.25rem;
  }
}
</style>
